const { VITE_APISERVER } = import.meta.env

const getTours = async ( key:string, referer:string ) => {

    try {
        const url = `${VITE_APISERVER}tours?key=${referer}${key}&formatted=yes`
  
        const res = await fetch(url)
        if (res) {
            return res.json()
        }
        else {
            return []
        }
    } catch (err) {
        return null
    }
}
export default getTours